import { krdetailConstants } from "../constants/krdetails.constants";
import { removeReactLoader } from "../utils/common.js";
const initialState = {
  mentionUser: [],
  dataFlowTree: false,
  krAlignTree: [],
};

const KrDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case krdetailConstants.UPDATE_INITIAL_PROPS:
      const krData = action.props;
      if (!krData) return state;
      return {
        ...state,
        metric: krData.metric,
        goal: krData.goal,
        team: krData.team
      };
    case krdetailConstants.GET_KRDETAILS_SUCCSESS:
      const upData = action.data;
      // if it is new KR
      if (upData.data.id && upData.data.id != state.id) {
        let previousTreeIds = state.previousTreeIds || [];
        const previousTreeIdLength = previousTreeIds.length;
        if (previousTreeIdLength) {
          const lastId = previousTreeIds[previousTreeIdLength - 1];
          if (lastId == upData.data.id) {
            previousTreeIds.pop();
          } else {
            previousTreeIds.push(state.id);
          }
        } else {
          previousTreeIds.push(state.id);
        }
        return {
          ...upData.data,
          previousTreeIds: previousTreeIds,
        };
      } else {
        let dataFlowTree = state.dataFlowTree;
        if (typeof action.oldId !== "undefined" && action.oldId) {
          dataFlowTree = false;
        }
        return {
          ...state,
          metric: upData.data.metric,
          goal: upData.data.goal,
          team: upData.data.team,
          dataFlowTree,
        };
      }
    case krdetailConstants.DATA_SOURCE_SUCCESS:
      let updateState = {
        dataSource: action.data.dataSource,
      };
      if (typeof state.viewTree !== "undefined" && state.viewTree == true) {
        if (
          typeof action.data.dataSource.cascadeTree !== "undefined" &&
          action.data.dataSource.cascadeTree == true
        ) {
          if (typeof updateState.dataFlowTree === "undefined") {
            updateState.dataFlowTree = true;
          }
        } else {
          if (typeof updateState.dataFlowTree !== "undefined") {
            updateState.dataFlowTree = false;
          }
        }
      }
      return {
        ...state,
        ...updateState,
      };
    case krdetailConstants.DATA_SOURCE_FAIL:
      return {
        ...state,
      };
    case krdetailConstants.GET_GRAPH_DATA_SUCCESS:
      return {
        ...state,
        graphData: action.data.chart_data,
        subGraphData: action.data.chart_data_sub,
        metricObj: action.data.metObj,
        goalObj: action.data.goalObj,
      };
    case krdetailConstants.GET_GRAPH_DATA_UPD:
      return {
        ...state,
        surveyUserSelected: action.surveyUser,
      };
    case krdetailConstants.GET_GRAPH_DATA_FAIL:
      return {
        ...state,
      };
    case krdetailConstants.GET_KR_ATTACHMENT_SUCCESS:
      return {
        ...state,
        attachments: action.data.data,
      };
    case krdetailConstants.KR_ATTACHMENT_DELETE_SUCCESS:
      return {
        ...state,
        attachments: state.attachments.filter((el) => el.id != action.attachId),
      };
    case krdetailConstants.SAVE_KR_ATTACHMENTS_SUCCSESS:
      removeReactLoader();
      return {
        ...state,
        attachments: state.attachments.concat(action.data),
      };
    case krdetailConstants.MENTION_USER_LISTS:
      return {
        ...state,
        mentionUser: action.data == "" ? [] : action.data,
      };
    case krdetailConstants.MENTION_USER_LISTS_EMPTY:
      return {
        ...state,
        mentionUser: [],
      };
    case krdetailConstants.GET_CASCADE_TREE_SUCCESS:
      return {
        ...state,
        treeData: action.data,
      };
    case krdetailConstants.SAVE_KR_NOTE:
      return {
        ...state,
        metric: { ...state.metric, description: action.data },
      };
    case krdetailConstants.GET_METRIC_BY_GOAL:
      let goalFromGoalList = state.dataSource.goalFromGoalList.map(
        (key, index) => {
          if (key.id == action.goalId.goalIds) {
            key.metric = action.data;
          }
          return key;
        }
      );
      return {
        ...state,
        dataSource: {
          ...state.dataSource,
          goalFromGoalList,
        },
      };
    case krdetailConstants.DATA_FLOW_TREE_STATUS:
      return {
        ...state,
        dataFlowTree: !state.dataFlowTree,
        viewTree: false,
      };
    case krdetailConstants.GET_ALIGN_TREE_DATA:
      return {
        ...state,
        krAlignTree: action.data,
      };
    case krdetailConstants.UPDATE_KR_REACTED_EMOJI:
      return {
        ...state,
        metric: { ...state.metric, reacted_emoji: action.data.reacted_emojis },
      };
    case krdetailConstants.UPDATE_METRIC_ATTRIBUTES:
      return {
        ...state,
        dataSource: { ...state.dataSource, metricAttributes: action.data },
      };
    case krdetailConstants.UPDATE_KR_HEADER_CONFIDENCE:
      return {
        ...state,
        metric: { ...state.metric, confidence: action.data },
      };

    case krdetailConstants.UPDATE_CLUSTER_SIMILAR_DATA:
      const id = state.metric.id;
      return {
        ...state,
        metric: { ...state.metric, clusterItems: action.data.metrics[id].cKR },
      };
    case krdetailConstants.COPY_KR_DATA_UPDATE:
      return {
        ...state,
        metric: {
          ...state.metric,
          ...action.data.metric,
        },
        goal: {
          ...state.goal,
          ...action.data.goal
        },
        team: {
          ...state.team,
          ...action.data.team
        },
        dataSource: {
          ...state.dataSource,
          ...action.data.dataSource
        }

      }
    case krdetailConstants.UPDATE_FUS_KR_ATTACHMENT_SUCCESS:
      return {
        ...state,
        attachments: state.attachments.map((el) => {
          if (el.fileId == action?.data?.resp?.id && action?.data?.resp?.path) {
            el.path = action?.data?.resp?.path
            el.fusStatus = action?.data?.resp?.fus_status
          }
          return el
        }),
      }

    default:
      return state;
  }
};

export default KrDetailsReducer;